import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { EmailService } from './email.service';
import { UserService } from './user.service';
import { Folder } from '../models/folder_model';
import { TestInfoModel } from '../models/test_info_model';
import { TestBackup } from '../models/test_backup_model';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  public selectedTestData;
  private _isLocal$ = new BehaviorSubject<boolean>(false);

  public isLocal$ = this._isLocal$.asObservable();

  public testStarted = false;

  setLocal(isLocal: boolean){
    this._isLocal$.next(isLocal);
  }

  constructor(private http:HttpClient, private userService: UserService, private emailService: EmailService) {

  }

   createTest(data):Promise<any>{
     return this.http.post(`${environment.apiBaseUrl}/tests/createTest`, data).toPromise().then(x=>{return x});
   }

   getEvaluatedTests(email):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/tests/getEvaluatedTests?email=${email}`);
  }

  getClientTests(email):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/tests/getClientTestsOld?email=${email}`);
  }

  getClientTestsExport(email):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/tests/getClientTests?email=${email}`);
  }

  
  getTestById(testId: string):Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/tests/getTestById/${testId}`);
  }

  updateTest(test, sendEmail = true):Observable<any>{
    if(test.isCompleted&&test.completeDate && sendEmail){
      var data = {
        user:test.evaluatedName,
        email:test.client,
        test:test.type,
        isCustomBrand: test.isCustomBrand
      }
      this.emailService.completeTest(data).subscribe();
    }
    return this.http.put(`${environment.apiBaseUrl}/tests/updateTest`, test);
  }

  updateTexts(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/tests/updateTexts`, data);
  }

  updateUseTexts(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/tests/updateUseTexts`, data);
  }

  getTexts():Observable<any>{
    return this.http.get(`${environment.apiBaseUrl}/tests/getTexts`);
  }

  uploadImage(data):Observable<any>{
    var formData = new FormData();
    formData.append("file", data);
    formData.append("upload_preset", "rfra7s5y");
    formData.append("cloud_name", "evalua-psi");
    formData.append("api_key", "873969673961712"); 
    return this.http.post(`https://api.cloudinary.com/v1_1/evalua-psi/image/upload`, formData);
  }

  createForm(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/tests/createForm`, data);
  }

  deleteForm(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/tests/deleteForm`, data);
  }

  updateForm(data):Observable<any>{
    return this.http.put(`${environment.apiBaseUrl}/tests/updateForm`, data);
  }

  getUserForms(data):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/tests/getUserForms`, data);
  }

  removeTest(testId: string):Observable<any>{
    return this.http.delete(`${environment.apiBaseUrl}/tests/removeTest/${testId}`);
  }

  createFolder(data: Folder):Observable<Folder>{
    return this.http.post<Folder>(`${environment.apiBaseUrl}/tests/createFolder`, data);
  }

  updateFolder(folderId: string, data: Partial<Folder>):Observable<Folder>{
    let body = {
      _id: folderId,
      ...data
    }
    return this.http.put<Folder>(`${environment.apiBaseUrl}/tests/updateFolder`, body);
  }

  getFolders(query: object):Observable<Folder[]>{
    return this.http.post<Folder[]>(`${environment.apiBaseUrl}/tests/getFolders`, query);
  }

  deleteFolder(folderId: string):Observable<any>{
    return this.http.delete(`${environment.apiBaseUrl}/tests/deleteFolder/${folderId}`);
  }

  createTestInfo(data: TestInfoModel):Observable<TestInfoModel>{
    return this.http.post<TestInfoModel>(`${environment.apiBaseUrl}/tests/createTestInfo`, data);
  }

  updateTestInfo(data: Partial<TestInfoModel>, id: string):Observable<TestInfoModel>{
    let body = {
      ...data,
      _id: id
    }
    return this.http.put<TestInfoModel>(`${environment.apiBaseUrl}/tests/updateTestInfo`, body);
  }

  getInfoTests(query: object):Observable<TestInfoModel[]>{
    return this.http.post<TestInfoModel[]>(`${environment.apiBaseUrl}/tests/getInfoTests`, query);
  }
  deleteTestInfo(testId: string):Observable<any>{
    return this.http.delete(`${environment.apiBaseUrl}/tests/deleteTestInfo/${testId}`);
  }

  createTestBackup(backup: Partial<TestBackup>): Observable<TestBackup> {
    return this.http.post<TestBackup>(`${environment.apiBaseUrl}/tests/createTestBackup`, backup);
  }

  getTestBackups(query: object): Observable<TestBackup[]> {
    return this.http.post<TestBackup[]>(`${environment.apiBaseUrl}/tests/getTestBackups`, query);
  }

  deleteTestBackup(backupId: string): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/tests/deleteTestBackup/${backupId}`);
  }

}
